import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import RoyalRingsStore from './store/RoyalRings.store'
import List from './components/List/List.component'
import EditModal from './components/EditModal/EditModal.component'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import PageHeading from './../../components/shared/PageHeading.component'

import './AdminRoyalRings.page.scss'

class AdminRoyalRingsPage extends Component {
  componentDidMount() {
    RoyalRingsStore.init()
  }

  render() {
    return (
      <Fragment>
        <DashboardLayout>
          <main id='AdminRoyalRingsPage' className='mainSection pb-5'>
            <MDBContainer fluid className='mt-4'>
              <PageHeading
                label='Royal Ring Recipients Administration'
                url={this.props?.match?.url}
                from={this.props?.location?.state?.from}
                goTo={url => this.props.history.push(url, { from: '/admin-royal-rings' })}
              />
              <MDBRow>
                <MDBCol size='12'>
                  <div className='content-wrapper'>
                    <List />
                  </div>
                </MDBCol>
              </MDBRow>
              <EditModal />
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AdminRoyalRingsPage
